import { noteTemplateFor } from './model/noteTemplates';
// Entry titles by local entry type (icons: components/EntryIcon.tsx; type maps: api-utils.ts)
const ENTRY_TITLES: Record<string, string> = {
  vitals: 'Vitals',
  mar: 'Meds (MAR)',
  feed: 'Feeding Record',
  notes: 'Notes',
  wound: 'Wound Care',
  incident: 'Incident',
  summary: 'Visit Summary',
  measurements: 'Measurements',
  addendum: 'Supervisor Addendum',
  respiratory: 'Respiratory',
  seizure: 'Seizure',
  output: 'Output',
  supervisory: 'Supervisory Note',
  therapy: 'Treatment Note',
  aidetasks: 'Aide Tasks',
};

// Helper function to get entry title from type
export const getEntryTitle = (type: string | null): string =>
  (type && (ENTRY_TITLES[type.toLowerCase()] || noteTemplateFor(type)?.label)) || 'Entry';
